import {
  DEFAULT_TERMINOLOGY_SECTOR,
  SECTOR_TERMINOLOGY_ALIASES,
  TERMINOLOGY_ASSETS_BASE_PATH,
} from '../../constants/terminology';
import { TerminologyDictionary, TerminologyParams } from '../../models/terminology.interface';

const SAFE_SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function normalizeSectorSlug(sector: string): string {
  if (/\.\.|[/\\]/.test(sector)) {
    return DEFAULT_TERMINOLOGY_SECTOR;
  }

  const slug = sector
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  if (!slug || !SAFE_SLUG_PATTERN.test(slug)) {
    return DEFAULT_TERMINOLOGY_SECTOR;
  }

  return slug;
}

export function resolveSectorCatalog(sector: string): string {
  const slug = normalizeSectorSlug(sector);
  return SECTOR_TERMINOLOGY_ALIASES[slug] ?? slug;
}

export function isTerminologyDictionary(value: unknown): value is TerminologyDictionary {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function lookupTerm(dictionary: TerminologyDictionary, key: string): string | undefined {
  const direct = dictionary[key];
  if (typeof direct === 'string') {
    return direct;
  }

  const segments = key.split('.').filter((segment) => segment.length > 0);
  if (segments.length === 0) {
    return undefined;
  }

  let current: unknown = dictionary;
  for (const segment of segments) {
    if (typeof current !== 'object' || current === null || Array.isArray(current)) {
      return undefined;
    }

    current = (current as TerminologyDictionary)[segment];
  }

  return typeof current === 'string' ? current : undefined;
}

export function interpolateTerm(template: string, params?: TerminologyParams): string {
  if (!params) {
    return template;
  }

  return template.replace(/\{(\w+)\}/g, (placeholder: string, token: string): string => {
    const value = params[token];
    return value == null ? placeholder : String(value);
  });
}

export function terminologyAssetUrl(catalog: string): string {
  return `${TERMINOLOGY_ASSETS_BASE_PATH}/${catalog}.json`;
}
